import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  useEffect(() => { document.title = 'About SpinWorld.Us | Alaskans Art N Around'; }, []);
  return (
    <main className="min-h-screen bg-[#f0f4f7]">
      {/* Hero */}
      <section className="relative h-[320px] md:h-[450px] overflow-hidden">
        <img
          src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/f852635d999a6daa222ef052ffeca98a.webp"
          alt="SpinWorld garden art"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 drop-shadow-lg">
            The Story Behind the Spinners
          </h1>
          <p className="text-white/80 text-base md:text-lg max-w-2xl drop-shadow">
            One woman, a love for kinetic art, and a mission to bring motion and beauty to gardens across America.
          </p>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-14 md:py-20">
        <div className="container-main">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
            <div>
              <p className="text-sm uppercase tracking-wider text-[#4f528d] font-semibold mb-3">Our Story</p>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-[#1A1A1A] mb-6 leading-tight">
                From Alaska to Wisconsin, Art That Moves
              </h2>
              <div className="space-y-4 text-[#4A4A4A] text-base leading-relaxed font-sans">
                <p>
                  The business, Alaskans Art-n-Around started in 1996 and expanded so Spin World could be founded. Spin World operates out of Madison, Wisconsin, a more centralized location than Juneau, Alaska. Ruth Olsen, owner of Spin World, loves to sell the mesmerizing laser cut, stainless steel, wind spinners at fairs, festivals and local events.
                </p>
                <p>
                  Her mission is to bring peace, tranquility and harmony to our customers through laser cut wind spinners, healing stone jewelry, and a connection to the earth and ancient world with woolly mammoth ivory, carved cow bone and fossils.
                </p>
                <p>
                  Ruth tumbles rocks she has found, makes beaded necklaces and sun catchers, crystal window candy, driftwood and shell items. She sells crystals, stones and fossils. Her medium includes glass, shells, crystals, woolly mammoth ivory, carved cow bone, and an outstanding line of semi-precious stones. Handmade Navajo crafts and dream catchers are available, as well as her handmade dream catchers and also ones made in Indonesia.
                </p>
                <p>
                  Spin World offers one of the largest selections of quality, laser cut wind spinners in the US, as well as mesmerizing, optical illusion, spinning tails. The 100% stainless steel laser cut wind spinners draw people in from afar when they spin and twirl. Comments of &ldquo;Mesmerizing&rdquo;, &ldquo;That is satisfying&rdquo; and &ldquo;How does that do that?&rdquo; are constantly heard.
                </p>
                <p>
                  Ruth provides an unparalleled selection of the very best quality products and an easy and comfortable shopping experience, and exceptional customer service.
                </p>
              </div>
            </div>
            <div className="relative">
              <div className="aspect-[4/5] rounded-lg overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/8d06bfc80ffb6612bf58ee5ce714cd6a.jpeg"
                  alt="Ruth with wind spinners"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 md:-left-10 bg-[#2c2a4a] text-white p-5 md:p-6 rounded-lg max-w-[200px] hidden md:block">
                <p className="font-serif text-2xl font-bold">70+</p>
                <p className="text-sm text-white/80">Unique wind spinner designs</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-14 md:py-20 bg-[#fcfcfc] border-t border-[#E8E0D4]">
        <div className="container-main">
          <div className="text-center mb-10 md:mb-14">
            <p className="text-sm uppercase tracking-wider text-[#4f528d] font-semibold mb-3">What We Stand For</p>
            <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-[#1A1A1A]">Our Values</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-[#eadce4] rounded-lg p-6 md:p-8 border border-[#E8E0D4] text-center">
              <div className="w-14 h-14 bg-[#2c2a4a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hammer-line text-2xl text-white" />
              </div>
              <h3 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Quality Craftsmanship</h3>
              <p className="text-[#4A4A4A] text-sm leading-relaxed font-sans">
                Every wind spinner is precision laser-cut from rustproof stainless steel. Our soapstone animals are hand-carved by artisans in Peru. We never compromise on materials or construction.
              </p>
            </div>

            <div className="bg-[#eadce4] rounded-lg p-6 md:p-8 border border-[#E8E0D4] text-center">
              <div className="w-14 h-14 bg-[#2c2a4a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-leaf-line text-2xl text-white" />
              </div>
              <h3 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Nature-Inspired Art</h3>
              <p className="text-[#4A4A4A] text-sm leading-relaxed font-sans">
                Our designs draw from the natural world — flowers, birds, butterflies, and sacred geometry. We believe art should bring people closer to nature, not further from it.
              </p>
            </div>

            <div className="bg-[#eadce4] rounded-lg p-6 md:p-8 border border-[#E8E0D4] text-center">
              <div className="w-14 h-14 bg-[#2c2a4a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-truck-line text-2xl text-white" />
              </div>
              <h3 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">US-Based Shipping</h3>
              <p className="text-[#4A4A4A] text-sm leading-relaxed font-sans">
                We ship every order from Madison, Wisconsin. No long international waits, no surprise import fees — just fast, reliable delivery of beautiful garden art to your door.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works / Process */}
      <section className="py-14 md:py-20">
        <div className="container-main">
          <div className="text-center mb-10 md:mb-14">
            <p className="text-sm uppercase tracking-wider text-[#4f528d] font-semibold mb-3">From Our Hands to Your Garden</p>
            <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-[#1A1A1A]">How It Works</h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {[
              { icon: 'ri-scissors-cut-line', title: 'Laser Cut', desc: 'Each wind spinner is precision cut from stainless steel using advanced laser technology for crisp, clean edges.' },
              { icon: 'ri-paint-brush-line', title: 'Hand Finished', desc: 'Artisans apply vibrant, weather-resistant coatings that catch sunlight and create stunning color shifts as the piece spins.' },
              { icon: 'ri-archive-line', title: 'Carefully Packed', desc: 'Every order is hand-packed in Madison, WI with protective materials to ensure your art arrives in perfect condition.' },
              { icon: 'ri-sun-line', title: 'Enjoy the Motion', desc: 'Hang your spinner and watch it come alive. Even a gentle breeze transforms it into a mesmerizing display of kinetic art.' },
            ].map((step, i) => (
              <div key={i} className="text-center">
                <div className="w-16 h-16 bg-[#2c2a4a] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${step.icon} text-2xl text-white`} />
                </div>
                <h3 className="font-serif text-lg font-bold text-[#1A1A1A] mb-2">{step.title}</h3>
                <p className="text-[#4A4A4A] text-sm leading-relaxed font-sans">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 md:py-20 bg-[#2c2a4a]">
        <div className="container-main text-center">
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
            Ready to Bring Motion to Your Garden?
          </h2>
          <p className="text-white/70 text-base md:text-lg max-w-xl mx-auto mb-8">
            Explore our full collection of wind spinners, soapstone animals, and wire-wrapped stones.
          </p>
          <Link
            to="/shop"
            className="inline-block py-3.5 px-10 rounded-md bg-[#4f528d] text-white font-sans font-semibold text-sm uppercase tracking-wider hover:bg-[#3d4070] transition-colors whitespace-nowrap"
          >
            Shop All Products
          </Link>
        </div>
      </section>
    </main>
  );
}